import React, { useState, useEffect } from "react"
import Paragraph from "../component/paragraph"
import MusicMap from "../component/music-map"
import '../style/layout.css'
import MediaModal from "../component/media-modal"
import 'bootstrap/dist/css/bootstrap.min.css';
import data from "../model/music.json"
import { Helmet } from 'react-helmet';
import logo from '../images/logo-redsatelliteradio.jpg'
import space from '../images/about-img.jpg'
import Contact from "../component/contact"
import Footer from "../component/footer"
import{ init, send } from 'emailjs-com';

const about = "RED SATELLITE RADIO is an online radio for discovering alternative music from socialist central-eastern europe in the second half of the 20th century. The music presented is usually a mix between eastern, western and regional influences and reflects the special in-between circumstances these countries had to face during the time of state-socialism and a global cold war. It is surprising and stunning at the same time how diverse, innovative and pleasant the works by artists from the subcultural undergrounds in the satellite states are, if you take into account how limited their possibilities for treating and unfolding their passion were. Unfortunately, a lot of this anyway rarely distributed music is in danger to disappear soon if not conserved properly and a lot of these amazing productions are already forgotten by most people. The platforms aim is to give these forgotten jams a second life so everyone can easily access unique and inspiring, sometimes funny music from a very distinct time-space constellation of european history. Besides being an archive, the music of the soviet satellite states should not only remain as it is but can be used as a source of material for new music productions and therefore transform its spirit in the 21st century through sampling, re-editing and mixing it with contemporary sounds. The project is open for contribution by anyone interested but also wants to encourage and support respectively people from central-eastern-europe to discover their cultural heritage and get creative with. The main page is an interactive map where one can listen to music selected by decade and country with various options to get random or topic-based playlists. Additionally, texts with background information, personal stories, photos, graphic design and other accompanying curated material can be found. Beside that, there will be regular live radio program including interviews, live DJ-sets and mixtapes circulating around the topic of alternative and unknown music from socialist central-eastern europe."

export default function Home() {
  const [modalShow, setModalShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    init("user_cANSeD4utkfg0KIlw1ckV");
  }, [])

  const openModal = e => {
    setSelectedId(e.target.id);
    setModalShow(true)
  }

  return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Red Satellite Radio</title>
      <link rel="canonical" href="https://redsatelliteradio.eu" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      <meta name="description" content="RED SATELLITE RADIO is an online radio for discovering alternative music from socialist central-eastern europe in the second half of the 20th century"></meta>
      <meta name="keywords" content="Music, Radio, Socialist, USSR, Eastern-Central Europe"></meta>
    </Helmet>
    <div style={{ borderBottom: '1px solid', width: '80%', display: 'flex', justifyContent: 'center' }}>
      <img style={{ maxWidth: '100%', height: 'auto' }} src={logo} />
    </div>
    <div className="map-container">
      <MusicMap onClick={openModal} />
    </div>
    <MediaModal anchor={500} data={data[selectedId]} show={modalShow} onHide={() => setModalShow(false)} />
    <div>
      <Paragraph text={about} title="About the project" src={space}/>
    </div>
    <Contact send={send}/>
    <Footer/>
  </div>

}
